"use client";

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: "2rem",
        background: "var(--mira-bg, #f5f5f4)",
        color: "var(--mira-text, #1c1917)",
      }}
    >
      <div style={{ maxWidth: 420, display: "grid", gap: 12 }}>
        <h1 style={{ margin: 0, fontSize: "1.35rem" }}>Мира не отрисовала страницу</h1>
        <p style={{ margin: 0, color: "var(--mira-muted, #78716c)" }}>
          {error.message || "Неизвестная ошибка рендера"}
        </p>
        <button
          type="button"
          onClick={reset}
          style={{
            border: "none",
            borderRadius: 8,
            padding: "10px 12px",
            background: "var(--mira-accent, #d97706)",
            color: "#1c1917",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Повторить
        </button>
      </div>
    </main>
  );
}
